import * as NUMBER from 'constant/number'
import { HOME_MENU_ITEM, ADMIN_MENU_GROUPS, ADMIN_MENU_ITEM } from 'constant/nav-menu-groups'
import { Menu } from 'antd'
import { HomeOutlined, SettingOutlined } from '@ant-design/icons'
import { Link, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { bindActionCreators } from 'redux'
import { getPossibleSites, resetState } from 'action/site'
import { openMenu } from 'action/menu'
import styles from './index.scss'
import siteMenus from './component/site-menus'

const { SubMenu } = Menu

const ADMIN_TITLE = 'Administration'
const ADMIN = 'admin'
const HOME = 'home'

const menuKeys = [ADMIN, HOME]
const isAnAdmin = (user) => user.user_type.name === ADMIN || user.is_site_admin_user_type
const getSelectedKeys = (menuOpen, selectedKeys, openKeys) => menuOpen ? selectedKeys : openKeys
const getMenuStyle = (menuOpen) => menuOpen ? styles.nav_menu_open : styles.nav_menu_closed

// eslint-disable-next-line max-lines-per-function
const SidebarMenu = ({ possibleSites, mode, user, getPossibleSites, site, resetState, menuOpen, mobileView, openMenu }) => {
  const history = useHistory()

  const [openKeys, setOpenKeys] = useState([])
  const [selectedKeys, setSelectedKeys] = useState([])
  const siteKeys = possibleSites.map((site) => (site.uuid))

  const onOpenChange = (keys) => {
    setSelectedSites([])
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === NUMBER.MINUS_ONE)
    if (siteKeys.includes(latestOpenKey) || menuKeys.includes(latestOpenKey)) {
      setSelectedKeys(latestOpenKey)
      setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
    } else {
      setOpenKeys(keys)
    }
  }

  const onSelect = ({ key }) => {
    setSelectedSites([])
    if (key) {
      if (key === HOME) {
        setOpenKeys([])
      }
     menuOpen ? setSelectedKeys([key]) : setOpenKeys([...openKeys, key])
    } else {
      setOpenKeys([])
      setSelectedKeys([])
    }
  }
  const [selectedSite, setSelectedSites] = useState([])
  useEffect(getPossibleSites, [])
  return (
    <div className={styles.sidebar_menu_wrapper}>
      <Menu
        className={classnames(styles.nav_menu, getMenuStyle(menuOpen))}
        mode={mode}
        onOpenChange={onOpenChange}
        onSelect={onSelect}
        openKeys={openKeys}
        selectable={true}
        selectedKeys={getSelectedKeys(menuOpen, selectedKeys, openKeys)}
      >
        <Menu.Item
          className={styles.home}
          icon={<HomeOutlined className={styles.home_icon} />}
          key={'home'}
          onClick={() => (history.replace(`${HOME_MENU_ITEM.key}`))}
        >
          {menuOpen || mobileView ? <Link to={HOME_MENU_ITEM.key}>{HOME_MENU_ITEM.navName}</Link> : null}
        </Menu.Item>
        {siteMenus(possibleSites, site, menuOpen, mobileView, openMenu, setSelectedSites, selectedSite, onSelect)}
        {isAnAdmin(user) && addSubMenu({ history, menuOpen, mobileView, openMenu, resetState, user })}
      </Menu>
    </div>
  )
}

const addSubMenu = ({ resetState, menuOpen, history, mobileView, user, openMenu }) => {
  return (menuOpen || mobileView
    ? <>
      <SubMenu
        icon={<SettingOutlined />}
        key='admin'
        title={ADMIN_TITLE}
      >
        {getAdminMenu(menuOpen, mobileView, user)}
      </SubMenu>
    </>
 : getCollapsedMenu(menuOpen, history, openMenu)
  )
}

const getAdminMenu = (menuOpen, mobileView, user) => ADMIN_MENU_GROUPS.filter(({ onlyAdmin }) => !onlyAdmin || (onlyAdmin && user.user_type.name === ADMIN)).map((item, index) =>
  item?.items?.length
  ? getSubmenu(item, index, resetState, menuOpen, mobileView)
  : (
    <Menu.Item
      icon={item.icon}
      key={index}
      onClick={resetState}
    >
      {menuOpen || mobileView
        ? <>
          <Link
            to={item.key}
          >{item.navName}</Link>
        </>
        : <div />}
    </Menu.Item>
  )
)

const getCollapsedMenu = (menuOpen, history, openMenu) => (
  <Menu.Item
    icon={<SettingOutlined />}
    key={'admin'}
    onClick={() => {
      openMenu()
      history.replace(`${ADMIN_MENU_ITEM.key}`)
    }}
  >
    {menuOpen && <Link to={ADMIN_MENU_ITEM.key}>{ADMIN_MENU_ITEM.navName}</Link>}
  </Menu.Item>)

const getSubmenu = (item, index, resetState, menuOpen, mobileView) => (
  <SubMenu
    icon={item.icon}
    key={item.icon}
    title={item.title}
  >
    {item.items.map(({ key, navName, icon }) => (
      <Menu.Item
        icon={icon}
        key={key}
        onClick={resetState}
      >
        {menuOpen || mobileView ? <Link to={key}>{navName}</Link> : <div />}
      </Menu.Item>
    ))}
  </SubMenu>
)

SidebarMenu.propTypes = {
  getPossibleSites: PropTypes.func,
  menuOpen: PropTypes.bool,
  mobileView: PropTypes.bool,
  mode: PropTypes.string,
  openMenu: PropTypes.func,
  possibleSites: PropTypes.array,
  resetState: PropTypes.func,
  site: PropTypes.object,
  user: PropTypes.object
}

const mapStateToProps = (state) => ({
  menuOpen: state.menu.open,
  mobileView: state.menu.mobile,
  possibleSites: state.site.possibleSites,
  user: state.auth.user
})

export default connect(mapStateToProps, (dispatch) => ({
  getPossibleSites: bindActionCreators(getPossibleSites, dispatch),
  openMenu: bindActionCreators(openMenu, dispatch),
  resetState: bindActionCreators(resetState, dispatch)
}))(SidebarMenu)
